import React, { useEffect } from "react";
import "./index.scss";
import { useSelector, useDispatch } from "react-redux";
import Alert from "@mui/material/Alert";
import { addToLanguage } from "../../Reducers/authReducer";

function Login() {
  const { countryCode } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    const redirectTimer = setTimeout(() => {
      dispatch(addToLanguage({ countryCode: "AE" }));
      window.open(window.location.origin, "_self");
    }, 1000);

    return () => clearTimeout(redirectTimer);
  }, [countryCode]);

  return (
    <div className="Alert__page">
      <div className="row Alert__message">
        <div className="col-md-6">
          <div className="country-alert-dialogue-section2">
            <Alert className="country-alert-dialogue" severity="info">
              <div>You've been redirected to United Arab Emirates (UAE).</div>
            </Alert>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
